module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap_01"
    }
  }, [_vm._v("The Highland Affair Report")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap_02#ucQkq79jTU5wMbxkZkoevGE"
    }
  }, [_vm._v("Other people")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap_03#uKzWAnuVgNcKKTLk9l2bxqD"
    }
  }, [_vm._v("Vincent Dacha")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap_04#u28RQEPNPQXgoSmq96OXTiB"
    }
  }, [_vm._v("Crashing Down")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_05#uaFoHdrsQKKrJgWnwcwtmBB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Mystic")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_06#urn3emOjexAXzjnKstboZJE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_07#ubWAuvEjr3xaZzvBtXeyzKF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Challengers")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_08#ugTZn5O6jxD4qT2gO2yBgJ6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amplify")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_09#uAnJ7xb7YppQ4etE3d5glV6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrival")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_10#uLNTy8m9rFERGc72asACH96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart and Home")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_11#uZc9EdshDwOAqsGVVCQDcJG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ridge War")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_12#u3M6nOSR87iBJCDupyqWn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_13#uQ4d7v3sXnjOBUOAtkUvnEA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Symmetry")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_14#uB46sYoVZtkYJVhFzdQ7jcD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barrister")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_15#uzyxS7cpwFYdL2wxXFoZyV7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preach")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_16#uWxqf2ckZ3ZTbJfuon7sLp4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oz")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_17#uRF7DMEwUGTIb4v32qdFVXA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beast of the Wind")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_18#unKnGzMtECJ77rWqJHQ8Ez6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tach-Four")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_19#uTmQBoPPAxsnLUPKzsrJ332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rubicon")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_20#uVayVpsL2Uqj8lD7QtT4oh4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_21#uX6qI2kSZfVWej9zpJuV2i7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lock Three")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_22#u48du5cU7PZjUikelcSd569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("News of the Day")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_23#ulbxI9ZWymczYDnwVzTpmND",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inferno")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_24#uDtxFWxc2xXc9xB8tvh2nHC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purgatorio")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_25#ukfZtYkk3HhB7gyjwQbyZv2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paradiso")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_26#uzeQrrKgZHqvzkiCaVdb4PC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monday")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_27#uTf4GC2rOJej6HXrbMNpvL4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Krakatoa")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_28#uQ425Y78dEYaVmmWFmk8SU8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shuffling the Dead")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_29#uRKVmkviz2OFsAOncvAVZz5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_30#ucXomxHJbSpemyhcQINZLd8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Call")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_31#ucmRXCfETautnQeEBUwoh5D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motley Crew")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_32#upcLNm4SaqLKxdSm9q6PwGA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In from the Cold")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_33#uO6DMHVlGHAHvnWJyBBy4N3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bad Guys")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_34#uVd7IpCMkUE5oG5Mr94CLJ4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overkill")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_35#u9bujIfgniJ8vwNdMjwTVF8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alpha")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_36#uwNESCIc83ihHUZtqoZ2iFB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunted")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_37#uBdgbAM6Ul5bnObkNAAY4h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exit Music")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_38#uVsr3GKFYExnacU7CIQuca8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worst Wicked Friend")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_39#uN8STFuh5sE7zQWICoM3yv6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perchance to Dream")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_40#uQHu7f7YYyxMxqDSVTq84uB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_41#uo4tymJB7pTT7BSkNcZz2LE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into Temptation")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_42#ugC3jeW2QJ3I8gbitFMA2K5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Still World")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_43#uYY9Vr9PcaplIcp9OkWxNjA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footfalls")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_44#u8KViLbmZl8k6fRnI3HhUE9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Call")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_45#u68jOVraQjjIemAZ7opbbF2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Challenger Mine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_46#ukhPnYosr9CRqWHxWYR36G5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grinding")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_47#ugrLKfdMCgGU3PDFkKcobTG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrieval")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_48#uRq4KcRw2ImGlLP8iJTNBU5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Darkness")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap_49#uLHO82vKxGTO74hlpiJEwF5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everything Is Illuminated")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea93f88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 72
// module chunks = 0